module.exports = __webpack_public_path__ + "media/src/ui/icons/iconBin-df14a494206b424edfb3abfdde17418d.svg";